import React from 'react';

import {StarsDisplay} from './Stars';

// Date formatter: legacy used PHP `date('M d, Y', $ts)`. Mirror
// "Mar 27, 2021" output on the client.
function fmtDate(value) {
    if (!value) return '';
    const d = typeof value === 'number'
        ? new Date(value > 1e12 ? value : value * 1000)
        : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const month = d.toLocaleString('en', {month: 'short'});
    const day = String(d.getDate()).padStart(2, '0');
    return `${month} ${day}, ${d.getFullYear()}`;
}

// One row in the testimonials list. Markup 1:1 with the legacy
// `templates/reviews.phtml` block so the existing
// `redesign.css :.testimonials-item*` rules paint it unchanged.
//
// `hidden=true` carries the `js-hidden-item` class which the legacy
// "Load more" button toggled via jQuery; the React version manages
// it through state in ReviewsPage.
export default function ReviewItem({feedback, hidden = false}) {
    const customerName = feedback?.customer?.name || 'Customer';
    const rate = feedback?.rate || 0;
    const message = feedback?.message || '';
    const workType = feedback?.order?.workType || feedback?.order?.work_type || '';
    const subject = feedback?.order?.subject || feedback?.order?.subject_type || '';
    const pages = feedback?.order?.pages || '';
    const writerId = feedback?.writer?.id || 0;
    const writerName = feedback?.writer?.name || 'Writer';

    return (
        <div className={`testimonials-item${hidden ? ' js-hidden-item' : ''}`}>
            <div className="testimonials-item__content">
                <div className="testimonials-item__head">
                    <div className="testimonials-item__left">
                        <img src="/_core/assets/themes/bidding/assets/images/user.svg" alt="user"/>
                        <div className="testimonials-item__name">{customerName}</div>
                    </div>
                    <div className="testimonials-item__right">
                        <StarsDisplay rate={rate}/>
                        <p className="testimonials__date">{fmtDate(feedback?.date)}</p>
                    </div>
                </div>
                <div className="testimonials-item__text">{message}</div>
            </div>
            <div className="testimonials-item__info">
                <div>
                    <div className="testimonials-item__description">
                        {workType}{workType ? ', ' : ''}
                        {subject}{subject ? ', ' : ''}
                        {pages}
                        {pages ? ' ' : ''}
                        {writerId ? 'by ' : ''}
                        {writerId ? (
                            <a href={`/writer/${writerId}`} className="testimonials__avtor">
                                {writerName}
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="testimonials-item__right mob">
                <div className="testimonials-item__status">&nbsp;</div>
                <StarsDisplay rate={rate}/>
            </div>
        </div>
    );
}
